export default __webpack_public_path__ + "static/media/motif5.1de418f8.jpg";